module.exports = __webpack_public_path__ + "img/circle-user-dark.805c3e4d.svg";